export default __webpack_public_path__ + "static/media/paystack.cddef57a.png";